import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BaseService } from "../../_shared/services/base.service";

import { SubscriptionDto, SubscriptionListDto } from "../models/subscription";

@Injectable({
  providedIn: "root",
})
export class SubscriptionService extends BaseService<SubscriptionDto, SubscriptionListDto> {
  constructor(
    protected override http: HttpClient,
    @Inject("BASE_URL") protected override baseUrl: string
  ) {
    super(http, baseUrl, "subscription");
  }

  getCurrent(): Observable<SubscriptionDto> {
    return this.get("/current");
  }

  startTrail(): Observable<boolean> {
    return this.http.put<boolean>(this.baseUrl + this.controller + "/startTrail", null);
  }

  getForOrganization(organizationId: number): Observable<SubscriptionDto> {
    return this.get(`/byOrganization/${organizationId}`);
  }
}
